<template>
    <router-link :to="'/dish/' + dish_id + '/log/' + id" class="item">
      <div class="icon">
        <font-awesome-icon :icon="['fal', 'memo-pad']" class="fa-lg" />
      </div>
      <div>
        <p class="title">{{ formattedDate }}</p>
        <small class="note">{{ bodys_reaction ?? "No notes logged" }}</small>
      </div>
      <font-awesome-icon class="chevron-icon fa-sm" :icon="['fas', 'chevron-right']" />
    </router-link>
  </template>
  
  <script setup lang="ts">
  import { computed } from 'vue';
  import { defineProps } from 'vue';
  import { useStore } from 'vuex';

  // Access Vuex store
  const store = useStore();
    
  const props = defineProps<{
    id?: number;
    date: string;
    anxiety_level: number;
    taste: string;
    bodys_reaction: string;
    additional_notes: string;
    dish_id: number;
  }>();


  const formattedDate = computed(() => {
    const dateObj = new Date(props.date);
    return dateObj.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
  });

  </script>

<style scoped>

    .item {
        width: 100;
        display: flex;
        flex-direction: row;
        background-color: transparent;
        align-items: center;
        gap: 15px;
        border-radius: 10px;
        padding: 8px;
    }

    .item:hover {
      background-color: #f2ece650;
      cursor: pointer;
    }

    .icon {
      width: 50px;
      height: 50px;
      background-color: #f2ece6;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .note {
      color: #a6917b;
      display: block;
      width: 200px;            /* Or any fixed width */
      white-space: nowrap;     /* Prevents line wrap */
      overflow: hidden;        /* Hides overflowed text */
      text-overflow: ellipsis; /* Adds ... at the end */
    }

    .chevron-icon {
      display: none;
      color: #a6917b;
      margin-left: auto;
      margin-right: 10px;
    }

    .item:hover .chevron-icon {
      display: block;
    }


</style>
